import classes from "./image.module.css";
import {DibJsonNode} from "../../types";
import {URLS} from "../../../../app/consts";

export const Image = ({node}: {node: DibJsonNode}) => {
    const src = node.element?.attributes?.src;

    if (!src) {
        return null;
    }

    const base = src.startsWith(URLS.DIBIMAGES_ROOT)
        ? undefined
        : URLS.DIBIMAGES_ROOT;
    const srcUrl = new URL(src, base);

    return (
        <img
            src={srcUrl.href}
            alt={node.element?.attributes?.alt ?? ""}
            className={classes.image}
            style={
                {
                    "--img-width": node.element?.attributes?.width
                        ? `${node.element?.attributes?.width}px`
                        : "100%",
                    "--img-height": node.element?.attributes?.height
                        ? `${node.element?.attributes?.height}px`
                        : "auto",
                } as React.CSSProperties
            }
        />
    );
};
